import React from "react";
import { LoadingScreen } from "@packsize/components";

import { useUser } from "../../../hooks";
import { InvalidAccessView } from "../../invalid-access";

interface AuthorizedRouteProps {
	readonly children: React.ReactNode;
	readonly permissions: string | string[];
}

export const AuthorizedRoute: React.FC<AuthorizedRouteProps> = ({ children, permissions }) => {
	const { hasAnyRole } = useUser();

	const matchedRoles = hasAnyRole(Array.isArray(permissions) ? permissions : [permissions]);

	if (matchedRoles === undefined) {
		return <LoadingScreen />;
	}

	if (matchedRoles) {
		return children;
	}

	return <InvalidAccessView />;
};
